import templateUrl from 'emun.vendor/vendor-dashboard-toolbar.htm'
import controller from 'emun.vendor/vendor-dashboard-toolbar.controller'

export default {
	bindings: {
		vendor: '<'
	},
	controller,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};